import angular, { ILogService, ITimeoutService } from 'angular'
import { tap } from 'rxjs'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { AppConfigService } from 'src/_candidato/comun/services/app-config.service'
import { NotificacionService } from 'src/_panel/module/uni-base/services/NotifService'
import { IMenuNavegacion, IModelMenu, INavegacionForm } from '../../../../model/candidato-api'
import { BaseFeaturesComponent } from '../_base/base-features.component'

class TarjetaMenuComponentCtrl extends BaseFeaturesComponent {
  menu!: IMenuNavegacion
  formulars!: INavegacionForm[]
  principal!: boolean
  forms: IMenuNavegacion[]

  verForms: boolean

  dirty = false
  esNuevo = false

  defaultactive = ''

  editaAccesoPublico = false
  editaAceptaLOPD = false
  editaAceptarRecaptcha = false

  constructor(
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos,
    appConfigService: AppConfigService
  ) {
    super(appConfigService)
  }

  $onInit(): void {
    this.$log.info('[TarjetaMenuComponentCtrl] onInit')

    this.forms = this.menu.forms || []

    this.esNuevo = !this.menu.m.idmen
    this.defaultactive = this.esNuevo ? '' : 'active'

    this.autoUnsub(
      //
      this._flags
        .pipe(
          tap((flags) => {
            this.editaAccesoPublico = flags.editaAccesoPublico
            this.editaAceptaLOPD = flags.editaAceptarLOPD
            this.editaAceptarRecaptcha = flags.editaAceptarRecaptcha
          })
        )
        .subscribe()
    )
  }

  $postLink() {
    this.$timeout(() => (this.$element.find('select') as any).formSelect(), 100)
  }

  guardarMenu() {
    if (this._esnuevo()) {
      this.menu.forms = this.forms

      this.AccesoDatos.GestionMenu_CLIENT.nuevoMenu(this.menu).then((response) => {
        this.menu = response
        this.forms = this.menu.forms

        this.dirty = false
      })
    } else {
      this.AccesoDatos.GestionMenu_CLIENT.actualizaMenu(this.menu).then((response) => {
        this.menu = response
        this.forms = this.menu.forms

        this.dirty = false
      })
    }
  }

  private _esnuevo() {
    return !this.menu.m.idmen
  }

  verFormularios() {
    if (this._esnuevo()) {
      this.NotifService.aviso('Entry is not saved, first save changes')
      return
    }

    this.verForms = !this.verForms
  }

  nuevoForm() {
    let _nuevo = {} as IMenuNavegacion

    _nuevo.m = {} as IModelMenu

    _nuevo.m.idmensuper = this.menu.m.idmen

    this.forms.push(_nuevo)
  }
}

angular.module('candidato').component('tarjetaMenu', {
  bindings: {
    menu: '<',
    formulars: '<',
    principal: '<',
  },
  controller: TarjetaMenuComponentCtrl,
  template: require('./tarjeta-menu.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/tarjeta-menu/tarjeta-menu.component.html"
})
